/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
    PersonToJSONTyped,
} from './Person';

/**
 * 
 * @export
 * @interface Player
 */
export interface Player {
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof Player
     */
    playerNumber?: number | null;
    /**
     * Goalkeeper designation for this team membership. Omit when updating a roster to preserve its existing designation. Unset outside a team roster.
     * @type {boolean}
     * @memberof Player
     */
    goalkeeper?: boolean | null;
    /**
     * 
     * @type {Person}
     * @memberof Player
     */
    person: Person;
}

/**
 * Check if a given object implements the Player interface.
 */
export function instanceOfPlayer(value: object): value is Player {
    if (!('person' in value) || value['person'] === undefined) return false;
    return true;
}

export function PlayerFromJSON(json: any): Player {
    return PlayerFromJSONTyped(json, false);
}

export function PlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Player {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
        'goalkeeper': json['goalkeeper'] == null ? undefined : json['goalkeeper'],
        'person': PersonFromJSON(json['person']),
    };
}

export function PlayerToJSON(json: any): Player {
    return PlayerToJSONTyped(json, false);
}

export function PlayerToJSONTyped(value?: Player | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'playerNumber': value['playerNumber'],
        'goalkeeper': value['goalkeeper'],
        'person': PersonToJSON(value['person']),
    };
}

